import script from "/app/pages/Users/change_password.vue?type=script";
import "/app/pages/Users/change_password.vue?type=style";
import { render } from "/app/pages/Users/change_password.vue?type=template";
script.render = render;
export default script;
